/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "558")
  

// 接口文档



export interface API76146Req {
  
  /** 会话组ID */
  sessionId: string;
  /** 用户ID */
  userId?: string;
};



export type API76146Res = boolean;


// 接口函数 76146 清除用户标记状态

export interface IUsePostAPI76146Return {
  /** 清除用户标记状态: 接口请求状态 */
  isAPI76146Loading: boolean;
  /** 清除用户标记状态: 接口请求返回数据 */
  dataAPI76146: API76146Res;
  /**  清除用户标记状态: 接口数据请求方法 */
  fetchAPI76146Data: (inputs: API76146Req, config?: YWRequestConfig) => Promise<API76146Res>;
  /** 清除用户标记状态: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI76146 = ():IUsePostAPI76146Return => {
  let isMount = true;
  const [isAPI76146Loading, setIsAPI76146Loading] = useState(false);
  const [dataAPI76146, setDataAPI76146] = useState<API76146Res>({} as API76146Res);
  const requestUrl = `${basePath}/yoaichat-im/user/session/clearMark`;

  const fetchAPI76146Data = async (inputs: API76146Req, config?: YWRequestConfig): Promise<API76146Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API76146Req>) || {}) as API76146Req;
    
  
    if ( isMount ) {
      setIsAPI76146Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API76146Res>(`${basePath}/yoaichat-im/user/session/clearMark`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI76146(res || {} as API76146Res);
        setIsAPI76146Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI76146Loading(false);
      }
      return false as unknown as API76146Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI76146Loading,
    dataAPI76146,
    fetchAPI76146Data,
    requestUrl,
  }
}

